import styled from 'styled-components';
import { ReactComponent as Pix } from '../../assets/icons/pix.svg';
import { ReactComponent as CopyFile } from '../../assets/icons/copy-file.svg';
import { ReactComponent as Message } from '../../assets/icons/message.svg';
import { ReactComponent as Whatsapp } from '../../assets/icons/whatsapp.svg';
import { ReactComponent as MailOpenOutline } from '../../assets/icons/mail-open-outline.svg';
import { ReactComponent as Download } from '../../assets/icons/download.svg';
import { ReactComponent as Printer } from '../../assets/icons/printer.svg';
import { ReactComponent as CreditCard } from '../../assets/icons/credit-card.svg';

export const LoadingContainer = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0 28px 0;

  @media screen and (max-width: 960px) {
    padding: 24px 20px 32px 20px;
    border-radius: 0;
  }
`;

export const Container = styled.div`
  width: 624px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const Line = styled.div`
  width: 700px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;

  @media screen and (max-width: 960px) {
    margin-bottom: 0px;
    width: 100%;
  }
`;

export const Title = styled.h2`
  font-weight: 700;
  font-size: 28px;
  color: ${(props) => props.theme.colors.primaryDark2};
  display: block;

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const BreadCrumb = styled.div`
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.primaryDark2};

  @media screen and (max-width: 960px) {
    display: none;
  }

  #bar {
    color: ${(props) => props.theme.colors.secundary};
  }

  #link {
    color: ${(props) => props.theme.colors.secundary};

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

export const Back = styled.div`
  display: none;

  @media screen and (max-width: 960px) {
    display: block;
  }
`;

export const Description = styled.h2`
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  color: ${(props) => props.theme.colors.black};
  margin-bottom: 21px;

  @media screen and (max-width: 960px) {
    font-size: 16px;
  }
`;

export const Detail = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 28px;
  color: ${(props) => props.theme.colors.gray};

  p {
    font-size: 14px;
    line-height: 130%;
    font-weight: 400;
    margin-bottom: 4px;
  }

  .spotlight {
    color: ${(props) => props.theme.colors.primaryDark2};
    font-weight: 700;
    font-size: 20px;
  }

  .space-right {
    margin-right: 4px;
  }

  .strong {
    font-weight: 700;
  }

  .time {
    display: flex;
    font-size: 12px;
    line-height: 130%;
  }
`;

export const PaymentCard = styled.div`
  width: 100%;
  height: 68px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  margin-bottom: 12px;
  padding: 20px 32px;
  display: flex;
  justify-content: space-between;

  &:hover {
    cursor: pointer;
  }

  .text {
    padding: 6px 0;
    font-size: 20px;
    color: ${(props) => props.theme.colors.black};
    flex-grow: 10;
    @media screen and (max-width: 960px) {
      padding: 10px 0;
    }
  }

  span {
    flex-grow: 1;
  }

  @media screen and (max-width: 960px) {
    height: 72px;
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    padding: 18px;

    .text {
      font-size: 16px;
    }
  }
`;

export const Icon = styled.div`
  color: ${(props) => props.theme.colors.primaryDark2};
  padding: 3px 0;

  @media screen and (max-width: 960px) {
    padding: 6px 0;
  }
`;

export const IconPix = styled(Pix)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconCreditCard = styled(CreditCard)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconCopyFile = styled(CopyFile)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconMessage = styled(Message)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconWhatsapp = styled(Whatsapp)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconMailOpenOutline = styled(MailOpenOutline)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconDownload = styled(Download)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconPrinter = styled(Printer)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

type PaymentInfo = {
  hasPortion?: boolean;
};

export const PaymentSectionInfo = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: auto;
  height: auto;
`;

export const DownPayment = styled.div<PaymentInfo>`
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: #7b86a3;
  margin-bottom: 8px;

  span {
    color: ${(props) => (props.hasPortion ? '#070c2f' : '#7b86a3')};
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: bold;
    font-size: ${(props) => (props.hasPortion ? '20px' : '14px')};
    line-height: ${(props) => (props.hasPortion ? '20px' : '18px')};
  }
`;

export const Portions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 130%;
  color: #7b86a3;
  margin: 4px 0;
`;
